import type { AccountStatus } from '@workflow/contracts'
import type { StatusTone } from '@workflow/ui'

/**
 * How each account status is shown. The words name the decision that put the
 * account there, not the database's word for the row; the marks are the
 * status system's own silhouettes, so an administrator scans the same shapes
 * they already read across the studio's surfaces.
 */
export const ACCOUNT_STATUS: Record<AccountStatus, { label: string; tone: StatusTone }> = {
  invited: { label: 'Invited', tone: 'idle' },
  pending: { label: 'Under Review', tone: 'review' },
  active: { label: 'Active', tone: 'done' },
  suspended: { label: 'Suspended', tone: 'waiting' },
  revoked: { label: 'Revoked', tone: 'attention' },
  rejected: { label: 'Rejected', tone: 'idle' },
}
